/**
 * Set timeout.
 * @param {function} fn
 * @param {?number} timeout
 * @returns {number}
 */
export function setTimeout(fn, timeout = 0) {
  return window.setTimeout(fn, timeout);
}

/**
 * Clear timeout.
 * @param {number} timeout
 */
export function clearTimeout(timeout = 0) {
  window.clearTimeout(timeout);
}
